import Vue from 'vue'
import VueRouter from 'vue-router'
import {getToken,delToken} from '../util/auth'
import NProgress from 'nprogress'
import routes from './route'
import store from '../store'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to,from,next)=>{
  NProgress.start();
  const meta = (to.meta || {});
  const isNotAuth = meta.isAuth === false;
  // console.log(to);
  if(!isNotAuth){
    if(getToken()){
      if(to.path=="/login"){
        delToken();
        // store.commit("setLoginRedirect",from);
      }
      next();
    }else{
      // store.commit("setLoginRedirect",from);
      next({ path: '/login' });
    }
  }else{
    next();
  }
});
router.afterEach((to)=>{
  NProgress.done();
  if(!(to.path=="/login"
  ||to.path=="/register"
  ||to.path=="/forgetpwd"
  ||to.path=="/editpwd")){
    store.commit("setLoginRedirect",to);
  }
 
});
export default router
